module.exports = __webpack_public_path__ + "static/succes-388e831f1f3ce7e77f00f422254685c8.png";